<template>
  <Frame class="frame">
    <template v-slot:body>
      <div class="body">
        <van-field
          v-model="remark"
          rows="5"
          autosize
          label=""
          type="textarea"
          maxlength="200"
          placeholder="请输入拒绝理由(必填)..."
          show-word-limit
        />
      </div>
    </template>
    <template v-slot:footer>
      <div class="footer">
        <!-- <div class="btn cancle">关闭</div> -->
        <div class="btn submit" @click="teacherAppCallbackServe">提交</div>
      </div>
    </template>
  </Frame>
</template>

<script>
import Frame from "@/components/frame.vue"
import { Toast } from "vant"
import { ref } from "vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
export default {
  name: "VisitorRefuseApply",
  components: {
    Frame,
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()

    const id = route.query.id || ""
    const remark = ref("")

    const teacherAppCallback = (params) =>
      store.dispatch("visitor/teacherAppCallback", params)
    const teacherAppCallbackServe = async () => {
      if (!remark.value) {
        Toast.fail('请输入拒绝理由！')
        return
      }
      let params = {
        id,
        isPass: false,
        reason: remark.value,
      }
      let r = await teacherAppCallback(params)
      let { success, message } = r
      if (success) {
        router.go(-1)
      } else {
        Toast.fail(message)
      }
    }

    const cancleEvt = () => {
      router.go(-1)
    }
    return {
      remark,
      teacherAppCallbackServe,
      cancleEvt,
    }
  },
}
</script>

<style lang="less" scoped>
.frame{
  height: 100vh;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 15px;
  background-color: #fff;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 345px;
    height: 36px;
    font-size: 15px;
    font-weight: 400;
    border-radius: 18px;
    border: 1px solid #4174fd;
    &.submit {
      color: #fff;
      background-color: #4174fd;
    }
  }
}
</style>
